module.exports = __webpack_public_path__ + "images/0cd9b9b39fd90964e992a48a9e52071f-IMG_0994.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/bedroom/IMG_0994.jpg
// module id = ./src/assets/images/slides/bedroom/IMG_0994.jpg
// module chunks = 0